import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { useParams } from "react-router-dom";
import { getData } from "../../../../utils/IndexedDB";
import SetupKonva from "../../../OfflineSetup/OfflineSetupControl/OfflineSetupControlKonva/OfflineSetupControlKonva";
import SnagOfflineForm from "./SnagOfflineForm";

export default function SnagOfflineControl() {
	const [formBody, setFormBody] = useState(null);
	const [formEditData, setFormEditData] = useState(null);
	const [roomId, setRoomId] = useState(null);
	const param = useParams();
	useEffect(() => {
		const initDB = async () => {
			try {
				const data = await getData(
					"OfflineModeData",
					"configurationStore",
					"configuration",
				);

				setFormBody(data);
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, []);
	useEffect(() => {
		const initDB = async () => {
			try {
				if (param.id) {
					const snagData = await getData("OfflineModeData", "Snag", param.id);
					setFormEditData(snagData);
				}
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, [param.id]);
	return (
		<div>
			<Helmet>
				<title>Snag-Offline-Control</title>
				<meta name="description" content="Offline Setup" />
			</Helmet>

			<div className="container-fluid">
				<div className="row">
					<SetupKonva
						col="col-lg-7"
						floorplan={formBody?.layoutUrlBase64}
						rooms={formBody?.rooms}
						setUniqueId={setRoomId}
						roomId={roomId}
						// setUniqueId={setUniqueId}
					/>
					<SnagOfflineForm
						formBody={formBody}
						formEditData={formEditData}
						setRoomId={setRoomId}
						roomId={roomId}
					/>
				</div>
			</div>
		</div>
	);
}
